import TagManager from 'react-gtm-module';

import { getConfig } from 'src/global-config';

let gtmInitialized = false;

// ----------------------------------------------------------------------

export function initializeGTM(): void {
  if (gtmInitialized) {
    return;
  }

  // Nothing to do without a GTM ID
  const gtmId = getConfig().googleTagManager.id.trim();
  if (!gtmId) {
    return;
  }

  gtmInitialized = true;
  TagManager.initialize({ gtmId });
}

// ----------------------------------------------------------------------

//Push to GTM via react-gtm-module.
export function pushDataLayer(entry: Record<string, unknown>): void {
  if (typeof window === 'undefined') {
    return;
  }
  TagManager.dataLayer({ dataLayer: entry });
}

//Custom GA4-compatible event
export function trackEvent(eventName: string, payload: Record<string, unknown> = {}): void {
  pushDataLayer({
    event: eventName,
    ...payload,
  });
}


 //Virtual page view for SPA route changes. Uses event name `spa_page_view`
export function trackPageView(path?: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  const page_path = path ?? `${window.location.pathname}${window.location.search}`;

  pushDataLayer({
    event: 'spa_page_view',
    page_path,
    page_location: window.location.href,
    page_title: typeof document !== 'undefined' ? document.title : '',
    app_mode: getConfig().appMode,
  });
}
